import { Navigate, Outlet, Route } from "react-router-dom";

import { App } from "@/App";
import { PartnerLoginRedirect } from "@/apps/partner/router/PartnerLoginRedirect";
import { AddDevice } from "@/apps/partner/views/AddDevice/AddDevice";
import PartnerDashboard from "@/apps/partner/views/Dashboard/PartnerDashboard";
import { WelcomePartnerPortal } from "@/apps/partner/views/Login/WelcomePartnerPortal";
import { PartnerPortal } from "@/apps/partner/views/PartnerPortal/PartnerPortal";
import Success from "@/apps/partner/views/Success/Success";
import Summary from "@/apps/partner/views/Summary/Summary";
import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner";
import { authenticatorRouteComponents } from "@/router/AuthenticatorRoutes";
import { ProtectedRoute } from "@/router/ProtectedRoute";
import redirects from "@/router/redirects";
import { NotFound } from "@/views/NotFound/NotFound";

const redirectRoutes = redirects.map((redirect) => (
  <Route
    key={redirect.from}
    path={redirect.from}
    element={<Navigate to={redirect.to} replace />}
  />
));

export const partnerRoutes = [
  <Route
    key="partnerIndexRedirect"
    index
    element={<Navigate to="/welcome" replace />}
  />,
  <Route
    key="partnerBaseRoute"
    path="/"
    element={
      <ProtectedRoute user="partner">
        <App />
      </ProtectedRoute>
    }
  >
    <Route index element={<Navigate to="/portal" replace />} />
    <Route path="/portal/cockpit" element={<Navigate to="/portal" replace />} />
    <Route path="/portal" element={<PartnerDashboard />}>
      <Route index element={<PartnerPortal />} />
      <Route path="add-device" element={<AddDevice />} />
      <Route path="add-device/summary" element={<Summary />} />
      <Route path="add-device/success" element={<Success />} />
    </Route>
  </Route>,
  ...authenticatorRouteComponents,
  <Route
    key="404-catchall"
    path="*"
    element={<Navigate to="/404" replace />}
  />,
  <Route key="404" path="/404" element={<NotFound />} />,

  <Route
    key="welcome-base"
    element={
      <PartnerLoginRedirect>
        <Outlet />
      </PartnerLoginRedirect>
    }
  >
    <Route key="welcome" path="/welcome" element={<WelcomePartnerPortal />} />
    <Route
      key="welcome-loading-spinner"
      path="/welcome/loading"
      element={<WelcomeLoadingSpinner />}
    />
  </Route>,
  ...redirectRoutes,
];
